import { useMemo } from "react";

import { deleteToken, getMessaging, getToken, onMessage } from "firebase/messaging";

import { FIREBASE_CONFIG } from "../../firebase/config";
import { useFirebase } from "../../firebase/useFirebase";

const { vapidKey } = FIREBASE_CONFIG;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useFirebaseNotifications = () => {
	const firebaseApp = useFirebase();
	const messaging = getMessaging(firebaseApp);

	return useMemo(
		() => ({
			getFcmToken: async (setFcmTokenToStorage: (token: string) => void): Promise<void> => {
				await getToken(messaging, { vapidKey })
					.then(fcmToken => {
						if (fcmToken) {
							setFcmTokenToStorage(fcmToken);
						}
					})
					.catch(error => {
						console.error("Firebase getFcmToken()", { error });
					});
			},
			onMessageListener: (onReceive: (m: { title: string; body: string }) => void): void => {
				onMessage(messaging, payload => {
					const title = payload?.notification?.title;
					const body = payload?.notification?.body;

					if (!!title && !!body) {
						onReceive({ title, body });
					}
				});
			},
			onDeleteFcmToken: async (): Promise<void> => {
				try {
					await deleteToken(messaging);
				} catch (error) {
					console.error("Firebase onDeleteFcmToken()", { error });
				}
			}
		}),
		[messaging]
	);
};

export default useFirebaseNotifications;
